import React from 'react'
import { Modal, Dropdown, Menu, Button, Descriptions, Tag, Divider } from 'antd'
import { DeleteOutlined, FrownOutlined, SafetyOutlined, SmileOutlined, SwapLeftOutlined, SwapRightOutlined,
         MailOutlined, EyeOutlined, ExclamationCircleOutlined, StopOutlined, LinkOutlined } from '@ant-design/icons'
import Form from './Form'
import moment from 'moment'

type Props = {
    id: ?any,
    to: string,
    cc: string,
    bcc: string,
    subject: string,
    body: string,
    html: string,
    direction: string,
    from_email: string,
    from_name: string,
    status: string,
    opened: boolean,
    bounced: boolean,
    delivered: boolean,
    click: boolean,
    complaint: boolean,
    delivered_at: string,
    opened_at: string,
    click_at: string,
    bounced_at: string,
    complaint_at: string,
    sent_at: string,
    received_at: string,
    create_at: string,
    deleted_at: string,
    timetosend_at: ?string,
    submitting: boolean,
    email_attachments: ?any,
    logo: string,
    resetPasswordModal: {},
    componentWillMount: (props: any) => void,
    onClickSubmit: () => void,
    onClickCancel: () => void,
    onClickDelete: () => void,
    onClickSendNow: () => void,
}

export default class extends React.PureComponent<Props> {

  componentWillMount = () => this.props.componentWillMount(this.props)

  getEventIcons = () => {
    const {
      delivered,
      opened,
      click,
      bounced,
      complaint,
      delivered_at,
      opened_at,
      click_at,
      bounced_at,
      complaint_at,
      direction,
    } = this.props


    // Only show events for outbound emails
    if (direction === 'inbound') return null

    const events = []

    if (delivered === true) {
      events.push(
        <div key="delivered" style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <MailOutlined style={{ color: '#52c41a', fontSize: 14, marginRight: 8 }} />
          <span>Delivered {delivered_at ? moment(delivered_at).format('DD MMM HH:mm') : ''}</span>
        </div>
      )
    }

    if (opened === true) {
      events.push(
        <div key="opened" style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <EyeOutlined style={{ color: '#1890ff', fontSize: 14, marginRight: 8 }} />
          <span>Opened {opened_at ? moment(opened_at).format('DD MMM HH:mm') : ''}</span>
        </div>
      )
    }

    if (click === true) {
      events.push(
        <div key="clicked" style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <LinkOutlined style={{ color: '#722ed1', fontSize: 14, marginRight: 8 }} />
          <span>Clicked {click_at ? moment(click_at).format('DD MMM HH:mm') : ''}</span>
        </div>
      )
    }

    if (bounced === true) {
      events.push(
        <div key="bounced" style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <StopOutlined style={{ color: '#ff4d4f', fontSize: 14, marginRight: 8 }} />
          <span>Bounced {bounced_at ? moment(bounced_at).format('DD MMM HH:mm') : ''}</span>
        </div>
      )
    }

    if (complaint === true) {
      events.push(
        <div key="complaint" style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <ExclamationCircleOutlined style={{ color: '#fa8c16', fontSize: 14, marginRight: 8 }} />
          <span>Complaint {complaint_at ? moment(complaint_at).format('DD MMM HH:mm') : ''}</span>
        </div>
      )
    }

    return events.length > 0 ? (
      <div>
        <Divider>Email Events</Divider>
        <div style={{ backgroundColor: '#f9f9f9', padding: 12, borderRadius: 4 }}>
          {events}
        </div>
      </div>
    ) : null
  }

  renderReadOnlyView = () => {
    const {
      subject,
      to,
      cc,
      bcc,
      body,
      html,
      direction,
      status,
      sent_at,
      received_at,
      created_at,
      from_email,
      from_name,
    } = this.props

    const timestamp = direction === 'inbound' ? received_at : sent_at
    const directionIcon = direction === 'inbound' ? <SwapLeftOutlined style={{ color: '#1890ff' }} /> : <SwapRightOutlined style={{ color: '#52c41a' }} />
    const directionText = direction === 'inbound' ? 'Received' : 'Sent'

    return (
      <div>
        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
          {directionIcon}
          <Tag color={direction === 'inbound' ? 'blue' : 'green'}>
            {directionText}
          </Tag>
          <span style={{ color: '#666' }}>
            {timestamp ? moment(timestamp).format('DD MMM YYYY HH:mm') : 'Unknown'}
          </span>
        </div>

        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="Subject">{subject || 'No subject'}</Descriptions.Item>
          {direction === 'inbound' && (
            <Descriptions.Item label="From">
              {from_name && from_email ? `${from_name} <${from_email}>` : from_email || 'Unknown sender'}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="To">{to || 'N/A'}</Descriptions.Item>
          {cc && <Descriptions.Item label="CC">{cc}</Descriptions.Item>}
          {bcc && <Descriptions.Item label="BCC">{bcc}</Descriptions.Item>}
          <Descriptions.Item label="Status">
            <Tag color={status === 'sent' ? 'green' : status === 'pending' ? 'blue' : status === 'failed' ? 'red' : 'orange'}>
              {status || 'Unknown'}
            </Tag>
          </Descriptions.Item>
        </Descriptions>

        <Divider>Email Content</Divider>

        {html ? (
          <div
            style={{
              border: '1px solid #f0f0f0',
              padding: 16,
              borderRadius: 4,
              backgroundColor: '#fafafa',
              maxHeight: 400,
              overflow: 'auto'
            }}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <div
            style={{
              border: '1px solid #f0f0f0',
              padding: 16,
              borderRadius: 4,
              backgroundColor: '#fafafa',
              whiteSpace: 'pre-wrap',
              maxHeight: 400,
              overflow: 'auto'
            }}
          >
            {body || 'No content'}
          </div>
        )}

        {this.getEventIcons()}
      </div>
    )
  }

  getOptionsMenu = () => {
    const {
      onClickDelete,
    } = this.props
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'delete') {
            onClickDelete()
          }
        }}
      >
        <Menu.Item key='delete'><DeleteOutlined />{` Delete`}</Menu.Item>
      </Menu>
    )
  }

  render() {

    const {
        id,
        team_id,
        owner_id,
        owner_type,
        project_id,
        subject,
        to,
        cc,
        bcc,
        body,
        html,
        direction,
        from_email,
        from_name,
        sent_by_user_id,
        status,
        email_attachments,
        opened,
        bounced,
        delivered,
        click,
        complaint,
        delivered_at,
        opened_at,
        click_at,
        bounced_at,
        complaint_at,
        sent_at,
        received_at,
        created_at,
        updated_at,
        timetosend_at,
        submitting,
        logo,
        onUpload,
        onClickSubmit,
        onClickCancel,
        onClickSendNow,
    } = this.props

    const isInbound = direction === 'inbound'
    const hasData = id && (subject || to || body || html)
    const isPendingWithFutureTime = status === 'pending' && timetosend_at && moment(timetosend_at).isAfter(moment())
    const isFailed = status === 'failed'
    const footer = []

    /*if (id) {
      footer.push([
        <Dropdown key='options' overlay={this.getOptionsMenu()}>
          <Button style={{ float: 'left' }} loading={submitting}>
            Options
          </Button>
        </Dropdown>,
      ])
    }*/

    if (isInbound) {
      // For inbound emails, only show Close button
      footer.push(
        <Button key='close' onClick={onClickCancel}>
          Close
        </Button>
      )
    } else {
      // For outbound emails, show Cancel and Save buttons
      if (isPendingWithFutureTime) {
        footer.push(
          <Button key='send-now' type='danger' disabled={submitting} onClick={onClickSendNow}>
            Send Now
          </Button>
        )
      }
      if (isFailed) {
        footer.push(
          <Button key='retry' type='primary' danger disabled={submitting} onClick={onClickSendNow}>
            Retry Send
          </Button>
        )
      }
      footer.push(
        <Button key='cancel' disabled={submitting} onClick={onClickCancel}>
          Cancel
        </Button>,
        <Button key='save' type='primary' loading={submitting} onClick={onClickSubmit}>
          Save
        </Button>
      )
    }

    return (

      <Modal
        title={isInbound ? 'View Email: ' + (subject || 'No Subject') : 'Edit Email: ' + (subject || 'No Subject')}
        footer={footer}
        onCancel={onClickCancel}
        width={700}
        visible
      >

        {!hasData ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            Loading email...
          </div>
        ) : isInbound ? (
          this.renderReadOnlyView()
        ) : (
          <Form
            id={id}
            team_id={team_id}
            owner_id={owner_id}
            owner_type={owner_type}
            project_id={project_id}
            subject={subject}
            to={to}
            cc={cc}
            bcc={bcc}
            body={body}
            html={html}
            sent_by_user_id={sent_by_user_id}
            status={status}
            email_attachments={email_attachments}
            opened={opened}
            bounced={bounced}
            sent_at={sent_at}
            created_at={created_at}
            updated_at={updated_at}
            submitting={submitting}
            logo={logo}
            onUpload={onUpload}
            timetosend_at={timetosend_at}
            onClickSendNow={onClickSendNow}
          />
        )}

      </Modal>

    )

  }

}
